import request from '@/utils/request';
import api from "./config";
import * as AES from "@/utils/aes.js";
export function login(data) {
  var params = JSON.parse(JSON.stringify(data));
  params.phone = AES.encryptAES(params.phone);
  params.password = AES.encryptAES(params.password);
  params.security = 1;
  return request({
    url: api.INTERFACE_LOGIN,
    method: 'post',
    data: params
  });
}
export function logout(data) {
  return request({
    url: api.INTERFACE_LOGIN_OUT,
    method: 'post',
    data: data
  });
}
export function getMenu(data) {
  return request({
    url: api.INTERFACE_GET_ASSISTANCE_TYPE,
    method: 'get',
    params: data
  });
}
export function getInfo(data) {
  return request({
    url: api.INTERFACE_GET_USER_INFO,
    method: 'post',
    data: data
  });
}
export function getGrade() {
  return request({
    url: api.INTERFACE_GET_GRADE,
    method: 'get'
  });
}
export function getClass(data) {
  return request({
    url: api.INTERFACE_GET_CLASS,
    method: 'get',
    params: data
  });
}
export function getGroupChildApi(data) {
  return request({
    url: api.INTERFACE_USER_GROUP_CHILD,
    method: 'get',
    params: data
  });
}
export function getSchoolStudentIdLabelApi(data) {
  return request({
    url: api.INTERFACE_GET_STUDENT_LIST_IDLABLE,
    method: 'post',
    data: data
  });
}
export function getGroupListApi(data) {
  return request({
    url: api.INTERFACE_USER_GROUP_LIST,
    method: 'post',
    data: data
  });
}
export function getUserList(data) {
  return request({
    url: api.INTERFACE_GET_ALL_USER_GET,
    method: 'get',
    params: data
  });
}
export function getAllSchoolUser(data) {
  return request({
    url: api.INTERFACE_MAIL_LIST_STUDENT,
    method: 'post',
    data: data
  });
}
export function getRoleList(data) {
  return request({
    url: api.INTERFACE_GET_ROLE_LIST,
    method: 'post',
    data: data
  });
}
export function AddGroupApi(data) {
  return request({
    url: api.INTERFACE_USER_GROUP_ADD,
    method: 'post',
    data: data
  });
}
export function getSchoolListApi(data) {
  return request({
    url: api.INTERFACE_USER_SCHOOL,
    method: 'post',
    data: data
  });
}
export function getSchoolStudentWithLabelApi(data) {
  return request({
    url: api.INTERFACE_GET_STUDENT_LIST_WITH_LABEL,
    method: 'post',
    data: data
  });
}
export function getStuByRole(data) {
  return request({
    url: api.INTERFACE_MAIL_LIST_STUDENT_BY_ROLE,
    method: 'post',
    data: data
  });
}
export function getCommonUnit(data) {
  return request({
    url: api.INTERFACE_COMMON_UNIT,
    method: 'get',
    params: data
  });
}
export function getRosters(data) {
  return request({
    url: api.INTERFACE_GET_ROSTERS,
    method: 'post',
    data: data
  });
}
export function exportRosters(data) {
  return request({
    url: api.INTERFACE_EXPORT_ROSTER,
    method: 'get',
    params: data
  });
}
export function addQuantitative(data) {
  return request({
    url: api.INTERFACE_ADD_QUANTITATIVE,
    method: 'POST',
    data: data
  });
}
export function getCurrentGrade() {
  return request({
    url: api.INTERFACE_CURRENT_GRADES,
    method: 'get'
  });
}
export function getCurrentClass(data) {
  return request({
    url: api.INTERFACE_CURRENT_CLASS,
    method: 'get',
    params: data
  });
}
export function getTeacherList(data) {
  return request({
    url: api.INTERFACE_SELECT_LIST_TEACHER_INFO,
    method: 'post',
    data: data
  });
}
export function getUserMenu(data) {
  return request({
    url: api.INTERFACE_GET_MEUN_LIST,
    method: 'post',
    data: data
  });
}